import { render } from "./secondaryAwarded.vue?vue&type=template&id=522912b6"
import script from "./secondaryAwarded.vue?vue&type=script&lang=js"
export * from "./secondaryAwarded.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__